import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { SectionDivider } from '../components/SectionDivider';
import { ProductSection } from '../components/ProductSection';
import { AboutSection } from '../components/AboutSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { IdentitySection } from '../components/IdentitySection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-566">
      <HeroSection data-id="element-567" />
      <StorySection data-id="element-568" />
      <PainSection data-id="element-569" />
      <MechanismSection data-id="element-570" />
      <SectionDivider data-id="element-571" />
      <AboutSection data-id="element-572" />
      <ProductSection data-id="element-573" />
      <TestimonialsSection data-id="element-574" />
      <OfferSection data-id="element-575" />
      <GuaranteeSection data-id="element-576" />
      <UrgencySection data-id="element-577" />
      <ObjectionsSection data-id="element-578" />
      <IdentitySection data-id="element-579" />
      <FinalCTASection data-id="element-580" />
      <Footer data-id="element-581" />
    </div>;
}